/**
 * @prettier
 */
export const text = {
  lineItem: {
    primaryTitle: {},
    secondaryTitle: {},
  },
};
